<template>
  <div class="pb-5">
    <v-col cols="12" class="py-0">
      <v-toolbar color="transparent" flat height="55">
        <v-spacer />
        <v-toolbar-items>
          <v-row align="center" justify="end" no-gutters>
            <template v-if="$helpers.hasSomePermission(['view_member', 'view_invitation'])">
              <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" outlined v-bind="attrs" v-on="on">
                    <v-icon left>mdi-export-variant</v-icon>Exportar<v-icon size="18" right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-3" @click="createExport('members')" :ripple="false">
                    <v-list-item-title class="body-2">Miembros</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-3" @click="createExport('invitations')" :ripple="false">
                    <v-list-item-title class="body-2">Invitaciones pendientes</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-query-builder class="mx-2" :query-map="filters" model="member" />
            </template>
            <v-btn v-if="$helpers.hasPermission(['add_invitation'])" @click="dialogCreate=true" color="primary"><v-icon left>mdi-account-plus</v-icon>Invitar miembro</v-btn>
          </v-row>
        </v-toolbar-items>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pt-0">
      <v-toolbar-title v-if="activeMembersList.length && ['Active', null].includes((($route || {}).query || {}).status || null)" class="subtitle-1 defaultGrey--text font-weight-bold">Miembros activos</v-toolbar-title>
    </v-col>
    <template v-if="!$store.state.accounts.LoaderMe">
      <PermissionDenied v-if="!$helpers.hasSomePermission(['view_member', 'view_invitation'])" :isDetail="true" />
      <template v-else>
        <!-- active -->
        <skeleton-list v-if="loadingActiveMembers" />
        <template v-else-if="['Active', null].includes((($route || {}).query || {}).status || null)">
          <v-col cols="12" class="py-0">
            <v-row>
              <v-col v-for="(d, index) in activeMembersList" :key="`${d.id}-${index}`" cols="4" :md="$vuetify.breakpoint.width < 1200 ? 3 : 2">
                <v-hover v-slot="{ hover }">
                  <v-card class="pa-5 rounded-md" :elevation="$helpers.hasPermission(['change_member']) && hover ? 5 : 0" flat @click="current = d.id, panel=true" :style="`cursor:${$helpers.hasPermission(['change_member']) ? 'pointer' :'default'}`">
                    <v-row no-gutters>
                      <v-tooltip color="bgSearch" right width="160px" :open-on-hover="d.is_owner" :open-on-click="false">
                        <template v-slot:activator="{on}">
                        <v-icon class="mb-1" color="primary" v-on="on">mdi-account{{ !d.is_owner ? '' : '-star' }}</v-icon>
                        </template>
                        <span class="d-block px-3 py-2">Dueño del espacio</span>
                      </v-tooltip>
                      <v-spacer />
                      <v-menu v-model="menuActiveMember[index]" close-on-click offset-y left :nudge-bottom="0" :nudge-left="25" transition="slide-y-transition">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mt-n1 mr-n2" text v-bind="attrs" v-on="on" :ripple="false">
                            <v-icon color="secondary" size="24">mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list class="pa-0">
                          <v-list-item class="px-3" @click="current = d.id, panel=true" :ripple="false">
                            <v-list-item-title class="body-2">Ver detalle</v-list-item-title>
                          </v-list-item>
                          <v-list-item class="px-3" v-if="$helpers.hasPermission(['view_group', 'change_group'])" @click="$router.replace({ name: 'AccountMemberUpdate', params: { id: d.id, ...currentParams}, query: {step: 0} })" active-class="transparent" :ripple="false">
                            <v-list-item-title class="body-2">Editar grupos</v-list-item-title>
                          </v-list-item>
                          <v-list-item class="px-3" v-if="$helpers.hasPermission(['change_member'])" @click="$router.replace({ name: 'AccountMemberUpdate', params: { id: d.id, ...currentParams}, query: {step: 1} })" active-class="transparent" :ripple="false">
                            <v-list-item-title class="body-2">Editar permisos</v-list-item-title>
                          </v-list-item>
                          <v-list-item class="px-3" v-if="$helpers.hasPermission(['delete_member'])" :ripple="false" @click="handlerDeleteMember('active', index)">
                            <v-list-item-title class="body-2">Desactivar miembro</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-row>
                    <span class="d-block">
                      <v-sheet class="transparent" height="25">
                        <span v-if="d.first_name.length && d.first_name !== ' '" class="secondary--text font-weight-medium body-1 d-inline-block text-truncate" style="max-width: 99%;">
                          <span class="text-capitalize">{{d.first_name | lower}} {{d.last_name | lower}}</span>
                        </span>
                        <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                      </v-sheet>
                    </span>
                    <span v-if="d.email.length" class="mt-n2 d-block body-2 fontDraw--text d-inline-block text-truncate" style="max-width: 99%; line-height: 22px;">{{d.email}}</span>
                    <span class="d-block mt-n1 body-2 text--disabled font-italic" v-else>Sin especificar</span>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
            <VMainPagination v-if="(showPagination || showAll) && activeMembersList.length" :count="activeMembersCount" @isActive="setQueryMembers('Active')"  />
          </v-col>
        </template>
        <!-- end active -->

        <!-- pendients -->
        <skeleton-list v-if="loadingInvitations" />
        <template v-else-if="['Accepted', null].includes((($route || {}).query || {}).status || null)">
          <template v-if="invitationsList.length && $helpers.hasPermission(['view_invitation'])">
            <v-col cols="12" :class="activeMembersList.length ? 'mt-2' : 'mt-0'">
              <v-toolbar-title class="subtitle-1 defaultGrey--text font-weight-bold">Invitaciones pendientes</v-toolbar-title>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-row>
              <v-col v-for="(d, index) in invitationsList" :key="`${d.id}-${index}`" cols="5" :md="$vuetify.breakpoint.width < 1300 ? 4 : 3" xl="2">
                <v-hover v-slot="{ hover }">
                  <v-card class="pa-5 rounded-md" :elevation="hover ? 5 : 0" flat>
                    <v-row no-gutters>
                      <v-icon class="mb-1" color="primary">mdi-account</v-icon>
                      <v-spacer />
                      <v-menu v-model="menuInvitation[index]" close-on-click  offset-y left :nudge-bottom="0" :nudge-left="25" transition="slide-y-transition">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mt-n1 mr-n2" @click="menuInvitation[index]=true" text v-bind="attrs" v-on="on" :ripple="false">
                            <v-icon color="secondary" size="24">mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list class="pa-0">
                          <v-list-item class="px-3" v-if="$helpers.hasPermission(['add_invitation']) && validateDate(d)" @click="resendInvitations(d)" :ripple="false">
                            <v-list-item-title class="body-2">Reenviar invitación</v-list-item-title>
                          </v-list-item>
                          <v-list-item class="px-3" v-if="!d.is_owner && $helpers.hasPermission(['delete_invitation']) && !validateDate(d)" @click="handlerDeleteInvitation(index)" :ripple="false">
                            <v-list-item-title class="body-2">Cancelar invitación</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-row>
                    <span class="d-block">
                      <v-sheet class="transparent" height="25">
                        <span v-if="d.name.length" class="secondary--text font-weight-medium body-1 d-inline-block text-truncate" style="max-width: 99%;">
                          <span class="text-capitalize">{{d.name | lower}}</span>
                        </span>
                        <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                      </v-sheet>
                    </span>
                    <span v-if="d.email.length" class="mt-n2 d-block body-2 fontDraw--text d-inline-block text-truncate" style="max-width: 99%; line-height: 22px;">{{d.email}}</span>
                    <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                    <v-col class="pa-0">
                      <div class="d-block d-flex mt-3 justify-space-between">
                        <div class="body-2 fontDraw--text">
                          Enviado el:
                          <span class="d-block" v-if="d.sent">{{ d.sent | dateTime }}</span>
                          <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                        </div>
                        <div class="body-2 fontDraw--text ml-5">
                          {{ validateDate(d) ? 'Expirado' : 'Expira' }} el:
                          <span class="d-block" v-if="d.due_date">{{ d.due_date | dateTime }}</span>
                          <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                        </div>
                      </div>
                    </v-col>
                  </v-card>
                </v-hover>
              </v-col>
              </v-row>
            </v-col>
            <VMainPagination class="mt-5" :count="invitationsCount" @isActive="setQueryInvitations()" />
          </template>
        </template>
        <!-- end pendients -->

        <!-- inactive -->
        <skeleton-list v-if="loadingInactiveMembers" />
        <template v-else-if="['Inactive', null].includes((($route || {}).query || {}).status || null)">
          <template v-if="inactiveMembersList.length && $helpers.hasPermission(['view_member'])">
            <v-col cols="12" class="my-2">
              <v-toolbar-title class="subtitle-1 defaultGrey--text font-weight-bold">Miembros inactivos</v-toolbar-title>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-row>
                <v-col v-for="(d, index) in inactiveMembersList" :key="`${d.id}-${index}`" cols="4" :md="$vuetify.breakpoint.width < 1200 ? 3 : 2">
                  <v-hover v-slot="{ hover }">
                    <v-card class="pa-5 rounded-md" :elevation="hover ? 5 : 0" flat @click="menuInactiveMember[index]=true">
                      <v-row no-gutters>
                        <v-icon class="mb-1" color="primary">mdi-account</v-icon>
                        <v-spacer />
                        <v-menu v-model="menuInactiveMember[index]" close-on-click offset-y left :nudge-bottom="0" :nudge-left="25" transition="slide-y-transition">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mt-n1 mr-n2" text v-bind="attrs" v-on="on" :ripple="false">
                              <v-icon color="secondary" size="24">mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list class="pa-0">
                            <v-list-item class="px-3" v-if="$helpers.hasPermission(['change_member'])" :ripple="false" @click="deleteMember('inactive', index)">
                              <v-list-item-title class="body-2">Activar miembro</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-row>
                      <span class="d-block">
                        <v-sheet class="transparent" height="25">
                          <span v-if="d.first_name.length && d.first_name !== ' '" class="secondary--text font-weight-medium body-1 d-inline-block text-truncate" style="max-width: 99%;">
                            <span class="text-capitalize">{{d.first_name | lower}} {{d.last_name | lower}}</span>
                          </span>
                          <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                        </v-sheet>
                      </span>
                      <span v-if="d.email.length" class="mt-n2 d-block body-2 fontDraw--text d-inline-block text-truncate" style="max-width: 99%; line-height: 22px;">{{d.email}}</span>
                      <span class="d-block mt-n1 body-2 text--disabled" v-else>Sin especificar</span>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
            <div id="inactive" />
            <VMainPagination class="mt-5" :count="inactiveMembersCount" @isActive="setQueryMembers('Inactive')" />
          </template>
        </template>
        <!-- end inactive -->
        <template v-if="!loadingInactiveMembers && !loadingInvitations && !loadingActiveMembers">
          <v-col cols="12" v-if="(!activeMembersList.length && !inactiveMembersList.length && !invitationsList.length) || ((($route || {}).query || {}).status) && (!activeMembersList.length || !inactiveMembersList.length || !invitationsList.length)">
            <v-empty-state type="suppliers" id="miembros" :isFree="true" title="No existen miembros">
              <!-- <template v-slot:actions>
                <template v-if="!routeList.includes($route.name)">
                  <v-btn @click="$emit('activeBtnFilter')" color="primary" :ripple="false" :width="153"><v-icon class="mr-2">mdi-filter-plus</v-icon>Filtrar</v-btn>
                  <v-btn class="ml-2" @click="setSort('-date')" outlined :ripple="false" width="153"><v-icon class="mr-2">mdi-text-search-variant</v-icon>Últimos registros</v-btn>
                </template>
              </template> -->
            </v-empty-state>
          </v-col>
        </template>
      </template>
    </template>
    <!-- dialog invitations -->
    <v-dialog v-model="dialogCreate" width="700" persistent no-click-animation overlay-color="overlay">
      <v-card flat outlined rounded>
        <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 fontBody--text font-weight-semibold">Invitar personas a {{account.name}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-3">
              <v-btn @click="dialogCreate=false" icon small retain-focus-on-click><v-icon color="fontBody" size="20">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-5 py-4">
          <v-list-item-subtitle>
            <v-row no-gutters>
              <v-col class="pa-0" cols="7">
                <span class="body-1 fontBody--text font-weight-medium">Email</span>
              </v-col>
              <v-col class="pa-0 pl-3" cols="4">
                <span class="body-1 fontBody--text font-weight-medium">Nombre</span>
              </v-col>
            </v-row>
            <v-row v-for="(d, i) in invitations" :key="i" no-gutters>
              <v-col class="py-1 pl-0 pr-2" cols="7">
                <v-text-field v-model.trim="$v.invitations.$each[i].email.$model" :error="$v.invitations.$each[i].email.$error" hide-details maxlength="254" outlined required single-line dense />
                <template v-if="((invitations || [])[i] || {}).email.length">
                  <span class="red--text caption py-1" v-if="!$v.invitations.$each[i].email.isUser">Ya es miembro de la cuenta</span>
                  <span class="red--text caption py-1" v-if="!$v.invitations.$each[i].email.isInvited">Tiene una invitación pendiente</span>
                </template>
              </v-col>
              <v-col class="py-1 pl-1 pr-0">
                <v-text-field v-model.trim="$v.invitations.$each[i].name.$model" :error="$v.invitations.$each[i].name.$error" hide-details outlined single-line dense />
              </v-col>
              <div class="pl-4" style="max-width:40px;">
                <v-btn v-if="i >= 1 || invitations.length > 1" @click="invitations.splice(i, 1)" icon text color="secondary" :ripple="false"><v-icon color="primary">mdi-delete</v-icon></v-btn>
              </div>
            </v-row>
            <v-row no-gutters>
              <v-col class="pa-0">
                <v-btn class="mt-n1" v-if="invitations.length < 10" @click.prevent="addRowInvitations" text color="primary" :ripple="false"><v-icon x-small>mdi-plus</v-icon>
                  <span class="font-weight-medium body-1">Agregar otro</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-subtitle>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-5 py-2">
          <v-spacer />
          <v-btn @click="dialogCreate=false" outlined>Cancelar</v-btn>
          <v-btn @click="handleInvitations" :loading="createLoader" color="primary">Enviar invitaciones</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog invitations -->

    <!-- <template v-show="panel"> -->
    <VPanel :active="panel" title="Información del miembro" @close="panel=false">
      <MemberRetrieve :active="panel" :id="current" @close="panel=false" @updateList="handleUpdate" />
    </VPanel>
  <!-- </template> -->

    <!-- dialog deleteMember -->
    <v-dialog v-model="dialogDelete" width="600" persistent no-click-animation overlay-color="overlay">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 fontBody--text font-weight-semibold">{{ deletecurrentMember.is_active ? 'Desactivar' : 'Activar' }} miembro</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogDelete=false" icon small retain-focus-on-click><v-icon color="fontBody" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 px-5 fontBody--text">
          <span class="d-block">¿Qué ocurre cuando se {{deletecurrentMember.is_active ? 'desactiva' : 'activa'}} un miembro?</span>
          <span class="d-block mt-4">1. El miembro {{deletecurrentMember.is_active ? 'ya no' : ''}} podrá trabajar en el espacio de trabajo.</span>
          <span class="d-block mt-2 mb-3">2. Toda la información creada por el miembro seguirá estando disponible.</span>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn @click="dialogDelete=false" outlined>Cancelar</v-btn>
          <v-btn color="primary" @click="deleteMember">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog deleteMember -->

    <!-- dialog invitation delete -->
    <v-dialog v-model="dialogDeleteInvitation" width="600" persistent no-click-animation overlay-color="overlay">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 fontBody--text font-weight-semibold">Eliminar invitación</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogDeleteInvitation=false" icon small retain-focus-on-click><v-icon color="fontBody" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 px-5 fontBody--text">
          <span class="d-block">{{ (invitationsList[currentDeleteInvitationID] || []).email || '' }} no podrá unirse a {{account.name}}</span>
          <span class="d-block mt-4 mb-3">Escribe <span class="font-weight-bold">“confirmar”</span> para continuar.</span>
          <v-text-field v-model="confirm" outlined single-line maxlength="9" dense hide-details />
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn @click="dialogDeleteInvitation=false" outlined>Cancelar</v-btn>
          <v-btn color="primary" @click="deleteInvitation" :disabled="confirm.toLowerCase() !== 'confirmar' ">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog invitation delete -->
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import SkeletonList from '@/components/commons/skeletonLoader/SkeletonList'
import VEmptyState from '@/components/commons/VEmptyState'
import { required, email, maxLength } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import ListViewMixin from '@/mixins/ListViewMixin'
import cloneDeep from 'lodash/cloneDeep'
import VMainPagination from '@/components/commons/VMainPagination'
import PermissionDenied from '@/modules/http/views/PermissionDenied'
import VPanel from '@/components/commons/VPanel'
import MemberRetrieve from '@/modules/account/views/members/MemberRetrieve'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'

export default {
  components: { VMainPagination, VEmptyState, SkeletonList, PermissionDenied, VPanel, MemberRetrieve, VQueryBuilder },
  mixins: [
    GenericViewMixin, ListViewMixin
  ],
  data: () => ({
    isUpdate: false,
    queryFilters: null,
    currentFilterStatus: null,
    deletecurrentMember: {},
    menuActiveMember: [false],
    menuInactiveMember: [false],
    menuInvitation: [false],
    dialogDelete: false,
    currentDeleteInvitationID: null,
    dialogDeleteInvitation: false,
    confirm: '',
    panel: false,
    current: null,
    isActive: false,
    loadingActiveMembers: false,
    loadingInactiveMembers: false,
    loadingInvitations: false,
    invitations: [
      { email: '', name: '' }
    ],
    dialogCreate: false,
    createLoader: false,
    activeMembersList: [],
    activeMembersCount: 0,
    inactiveMembersList: [],
    inactiveMembersCount: 0,
    instanceInvitationsList: [],
    filters: [
      {
        type: 'text',
        id: 'first_name',
        label: 'Nombre',
        value: null,
        category: 'a',
        operators: ['']
      },
      {
        type: 'text',
        id: 'email',
        label: 'Email',
        value: null,
        category: 'b',
        operators: ['']
      },
      {
        type: 'select',
        id: 'status',
        label: 'Estado',
        valueType: '',
        value: null,
        choices: [
          {label: 'Activo', value: 'Active'},
          {label: 'Inactivo', value: 'Inactive'},
          {label: 'Pendiente', value: 'Accepted'}
        ],
        category: 'c'
      }
    ]
  }),
  computed: {
    ...mapState({
      membersList: state => cloneDeep(state.accounts.membersList),
      count: state => cloneDeep(state.accounts.membersCount),
      invitationsList: state => state.accounts.invitationsList,
      invitationsCount: state => cloneDeep(state.accounts.invitationsCount)
    }),
    validateDate () {
      return (item = {}) => {
        return moment().isAfter(item.due_date)
      }
    }
    // currentParams () {
    //   let params = JSON.parse(JSON.stringify(this.$route.params))
    //   delete params.id
    //   return params
    // }
  },
  watch: {
    dialogCreate () {
      if (this.dialogCreate) {
        return false
      }
      this.$v.invitations.$reset()
    },
    '$route.query': {
      handler (val) {
        if (val) {
          this.currentFilterStatus = val?.status ?? null
          if (['Active', 'Inactive'].includes(val.status)) {
            this.getMembers(val.status)
          } else if (val.status === 'Accepted') {
            this.getInvitations()
          } else {
            this.getListMembers()
          }
        }
      }
    }
  },
  created () {
    // if (Object.keys(this.$route.query).length) this.$router.replace({ query: null })
    if (['Active', 'Inactive'].includes(this.$route.query.status)) {
      this.getMembers(this.$route.query.status)
    } else if (this.$route.query.status === 'Accepted') {
      this.getInvitations()
    } else {
      this.getListMembers()
    }
  },
  methods: {
    setQueryMembers (key = '') {
      this.$router.replace({ params: this.$route.params, query: {...(!!Object.keys(this.$route.query).find((filter) => 'page'.includes(filter)) && { page: this.$route.query.page }), is_active: key === 'Active' } }).catch(err => err)
      this.getMembers(key)
    },
    setQueryInvitations () {
      this.$router.replace({ params: this.$route.params, query: {...(!!Object.keys(this.$route.query).find((filter) => 'page'.includes(filter)) && { page: this.$route.query.page }), accepted: 'False'} }).catch(err => err)
      this.getInvitations()
    },
    getListMembers () {
      this.getMembers('Inactive')
      this.getMembers('Active')
      this.getInvitations()
    },
    handleUpdate () {
      this.panel = false
      this.getListMembers()
    },
    getMembers (key = '') {
      let query = JSON.parse(JSON.stringify(this.$route.query))
      if (query?.status) delete query.status
      if (this.$helpers.hasPermission(['view_member'])) {
        this[`loading${key}Members`] = true
        this.$store.dispatch('accounts/LIST', {
          resource: 'members',
          query: {
            ...query,
            is_active: this.$route?.query?.status === 'Active' || key === 'Active' ? 'true' : 'false'
          }
        })
        .then((response) => {
          const { next, results } = response.data
          this[`${key.toLowerCase()}MembersList`] = results
          this[`${key.toLowerCase()}MembersCount`] = !!next
        })
        .finally(() => {
          this[`loading${key}Members`] = false
          this.isUpdate += 1
        })
      }
    },
    getInvitations () {
      let query = JSON.parse(JSON.stringify(this.$route.query))
      if (query?.first_name) delete query?.first_name
      if (query?.status) delete query.status

      query = {...query, ...(this.$route.query.first_name && { name: this.$route.query.first_name}) }
      if (this.$helpers.hasPermission(['view_invitation'])) {
        this.loadingInvitations = true
        this.$store.dispatch('accounts/LIST', {
          resource: 'invitations',
          query: {
            ...query,
            accepted: this.$route.query.status ? 'True' : 'False'
          }
        })
        .then((response) => {
          this.instanceInvitationsList = [...response.data.results]
          this.instanceInvitationsList.forEach((item) => {
            item.due_date = moment(item.sent).add(3, 'days')
          })
        })
        .finally(() => {
          this.loadingInvitations = false
        })
      }
    },
    resendInvitations (invitation = {}) {
      this.invitations = [{ email: invitation.email, name: invitation.name }]
      this.postInvitations()
    },
    handleInvitations () {
      this.$v.invitations.$touch()
      if (this.$v.invitations.$invalid) {
        return false
      }
      this.postInvitations()
    },
    postInvitations () {
      this.createLoader = true
      this.$store.dispatch('accounts/BULK_INVITATION', {
        persons: this.invitations
      })
      .then(() => {
        this.invitations = [
          { email: '', name: '' }
        ]
        this.$v.invitations.$reset()
        this.getInvitations()
        this.$dialog.message.info('Las invitaciones han sido enviadas')
      })
      .catch((error) => {
        if (error.toString().search('400') !== -1) {
          this.dialogCreate = false
        }
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.createLoader = false
      })
    },
    patchMember (key = '', i = {}) {
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'members',
        payload: {
          is_admin: !this[`${key}MembersList`][i].is_admin
        },
        id: this[`${key}MembersList`][i].id
      })
      .then(() => {
        this.$store.dispatch('accounts/LIST', {
          resource: 'members',
          loader: false,
          query: {
            is_active: true
          }
        })
        .then((response) => {
          const { count, results } = response.data
          this.activeMembersList = results
          this.activeMembersCount = count
        })
        this.$dialog.message.info('El tipo de cuenta del miembro se ha actualizado')
      })
    },
    handlerDeleteMember (key = '', i = {}) {
      this.dialogDelete = true
      this.deletecurrentMember = this[`${key}MembersList`][i]
    },
    deleteMember (key = '', i = {}) {
      if (key === 'inactive') this.deletecurrentMember = this[`${key}MembersList`][i]
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'members',
        payload: {
          is_active: !this.deletecurrentMember.is_active
        },
        id: this.deletecurrentMember.id
      })
      .then(() => {
        this.getListMembers()

        this.$dialog.message.info(`El miembro ha sido ${this.deletecurrentMember.is_active ? 'desactivado' : 'activado'} en la organización`)
      })
      .finally(() => {
        this.dialogDelete = false
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    handlerDeleteInvitation (i = '') {
      this.dialogDeleteInvitation = true
      this.currentDeleteInvitationID = i
    },
    deleteInvitation () {
      this.$store.dispatch('accounts/DESTROY', {
        resource: 'invitations',
        id: this.invitationsList[this.currentDeleteInvitationID].id
      })
      .then(() => {
        this.getInvitations()
        this.$dialog.message.info('La invitación ha sido eliminada')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data.detail))
      })
      .finally(() => {
        this.dialogDeleteInvitation = false
      })
    },
    addRowInvitations () {
      this.invitations.push({
        email: '',
        name: ''
      })
    },
    createExport (key = '') {
      let query = JSON.parse(JSON.stringify(this.$route.query))
      if (query?.status) delete query.status
      if (key === 'invitations') {
        if (query?.first_name) delete query?.first_name
        query = {...query, ...(this.$route.query.status === 'Accepted' && { accepted: this.$route.query.status === 'Accepted' ? 'False' : 'True' }), ...(this.$route.query.first_name && { name: this.$route.query.first_name}) }
      } else {
        query = {...query, ...(['Active', 'Inactive'].includes(this.$route.query.status) && { is_active: this.$route.query.status === 'Active' }) }
      }

      this.$store.dispatch('batch/LIST', {
        resource: `${key}/export_to_csv`,
        query: query,
        loader: false,
        responseType: 'arraybuffer'
      })
      .then((response) => {
        const content = Buffer.from(response.data, 'base64')
        saveAs(new Blob([content], {type: 'application/csv'}), `Listado de ${key === 'members' ? 'miembros' : 'invitaciones'}.csv`)
        this.$dialog.message.info('La exportación se realizó con éxito')
      })
      .catch((response) => {
        this.$dialog.message.error('Ha ocurrido un error en la exportación')
      })
      .finally(() => {
        this.dialogExport = false
      })
    }
  },
  validations: {
    invitations: {
      $each: {
        email: {
          required,
          email,
          maxLength: maxLength(254),
          isUser: function (value) {
            return !this.membersList.filter(member => member.email === value).length
          },
          isInvited: function (value) {
            return !this.invitationsList.filter(invitation => invitation.email === value).length
          }
        },
        name: {
          required,
          maxLength: maxLength(32)
        }
      }
    }
  }
}
</script>